import { createRequiredValidators } from "@xo/client-common";
import { Type1Base } from "./Type1Base";

export function createType1BaseValidators() {
    return [
        ...createRequiredValidators<Type1Base>(["name"]),
    ];
}
